import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import RemoveScroll from "./auth-service-tools285.js";
import { getDefaultZIndex } from "./auth-service-tools182.js";
import { getShadow, getSpacing } from "./auth-service-tools185.js";
import { Box } from "./auth-service-tools244.js";
import { OptionalPortal } from "./auth-service-tools275.js";
import { ModalBaseProvider } from "./auth-service-tools286.js";
import { useModal } from "./auth-service-tools287.js";
const ModalBase = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    keepMounted,
    opened,
    onClose,
    id,
    transitionProps,
    trapFocus,
    closeOnEscape,
    returnFocus,
    closeOnClickOutside,
    withinPortal,
    portalProps,
    lockScroll,
    children,
    zIndex,
    shadow,
    padding,
    __vars,
    unstyled,
    removeScrollProps,
    ...others
  } = _ref;
  const {
    _id,
    titleMounted,
    bodyMounted,
    shouldLockScroll,
    setTitleMounted,
    setBodyMounted
  } = useModal({
    id,
    transitionProps,
    opened,
    trapFocus,
    closeOnEscape,
    onClose,
    returnFocus
  });
  const {
    key: removeScrollKey,
    ...otherRemoveScrollProps
  } = removeScrollProps || {};
  return /* @__PURE__ */jsxRuntimeExports.jsx(OptionalPortal, { ...portalProps,
    withinPortal,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(ModalBaseProvider, {
      value: {
        opened,
        onClose,
        closeOnClickOutside,
        transitionProps: { ...transitionProps,
          keepMounted
        },
        getTitleId: () => `${_id}-title`,
        getBodyId: () => `${_id}-body`,
        titleMounted,
        bodyMounted,
        setTitleMounted,
        setBodyMounted,
        trapFocus,
        closeOnEscape,
        zIndex,
        unstyled
      },
      children: /* @__PURE__ */jsxRuntimeExports.jsx(RemoveScroll, {
        enabled: shouldLockScroll && lockScroll,
        ...otherRemoveScrollProps,
        children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
          ref,
          ...others,
          __vars: { ...__vars,
            "--mb-z-index": (zIndex || getDefaultZIndex("modal")).toString(),
            "--mb-shadow": getShadow(shadow),
            "--mb-padding": getSpacing(padding)
          },
          children
        })
      }, removeScrollKey)
    })
  });
});
ModalBase.displayName = "@mantine/core/ModalBase";
export { ModalBase };